import { isServer, QueryClient } from "@tanstack/react-query";

const makeQueryClient = () =>
  new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 1000 * 60 * 5,
        refetchOnMount: true,
        refetchOnWindowFocus: false,
        refetchOnReconnect: true,
      },
    },
  });

let browserQueryClient: QueryClient;

export const getQueryClient = () => {
  if (isServer) return makeQueryClient();
  return browserQueryClient;
};

if (!isServer) {
  browserQueryClient = makeQueryClient();
}

export default getQueryClient;
